import { useContext } from 'react';
import { TvPlanContext } from "../../contexts/tvplancontext";


function TvPlanFooter(props) {
    const ctx = useContext(TvPlanContext);
    const logos = ctx.getConfig('logos');

    return (
        <div className="tv-plan-footer">
            {logos.footer.logo1 && (<img className="org-logo" alt="logo1" src={logos.footer.logo1} />)}
            {logos.footer.logo2 && (<img className="org-logo" alt="logo2" src={logos.footer.logo2} />)}
            <br />
            {logos.footer.licence || ""}
            <br />
            {logos.footer.logo3 && (<img className="org-logo" alt="logo3" src={logos.footer.logo3} width="60" />)}
        </div>
    );
}


export default TvPlanFooter;